import React, { useState } from 'react';
import { sendBookingRequest } from '../utils/email';
import { consumeDiscountCode } from '../utils/discounts';
import { generateReservationNumber } from '../utils/reservation';

const initialForm = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  travellers: '2',
  message: '',
  agree: false,
};

/** Rezervačný formulár – po odoslaní pošle požiadavku majiteľovi e-mailom. */
export default function BookingForm({ startKey, endKey, quote, discountCode }) {
  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error
  const [reservationNumber, setReservationNumber] = useState(null);

  const ready = Boolean(startKey && endKey && quote);

  const update = (field) => (event) => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    setForm((previous) => ({ ...previous, [field]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!ready || !form.agree) return;
    setStatus('sending');
    const reservation = generateReservationNumber();
    setReservationNumber(reservation);
    try {
      const result = await sendBookingRequest({
        form,
        startKey,
        endKey,
        quote,
        discountCode,
        reservationNumber: reservation,
      });
      if (result.method === 'emailjs') {
        // Použitý kupón: odpočítaj jedno použitie (kvótové kupóny).
        if (discountCode) await consumeDiscountCode(discountCode);
        setStatus('sent');
      } else {
        // mailto záloha – správa sa len predvyplnila v e-mailovom klientovi
        setStatus('mailto');
      }
    } catch (error) {
      setStatus('error');
    }
  };

  if (status === 'sent') {
    return (
      <div className="bform__success" role="status">
        <h3>Ďakujeme! 🚐</h3>
        <p>
          Tvoja požiadavka bola odoslaná. Ozveme sa ti čo najskôr s potvrdením
          termínu a ďalšími krokmi.
        </p>
        <p className="bform__reservation">
          Číslo rezervácie: <strong>{reservationNumber}</strong>
        </p>
      </div>
    );
  }

  if (status === 'mailto') {
    return (
      <div className="bform__success" role="status">
        <h3>Ešte jeden krok ✉️</h3>
        <p>
          Otvorili sme tvoju e-mailovú aplikáciu s predvyplnenou správou –
          skontroluj ju a odošli. Ak sa nič neotvorilo, napíš nám prosím
          priamo na uvedený e-mail v sekcii Kontakt.
        </p>
        <p className="bform__reservation">
          Číslo rezervácie: <strong>{reservationNumber}</strong>
        </p>
      </div>
    );
  }

  return (
    <form className="bform" onSubmit={handleSubmit} aria-label="Rezervačný formulár">
      <h3>Údaje o tebe</h3>

      {!ready && (
        <p className="bform__notice">
          Najprv si prosím vyber termín v kalendári vyššie.
        </p>
      )}

      <div className="bform__grid">
        <div className="bform__field">
          <label htmlFor="bf-first">Meno *</label>
          <input id="bf-first" type="text" required autoComplete="given-name"
            value={form.firstName} onChange={update('firstName')} />
        </div>
        <div className="bform__field">
          <label htmlFor="bf-last">Priezvisko *</label>
          <input id="bf-last" type="text" required autoComplete="family-name"
            value={form.lastName} onChange={update('lastName')} />
        </div>
        <div className="bform__field">
          <label htmlFor="bf-email">E-mail *</label>
          <input id="bf-email" type="email" required autoComplete="email"
            value={form.email} onChange={update('email')} />
        </div>
        <div className="bform__field">
          <label htmlFor="bf-phone">Telefón *</label>
          <input id="bf-phone" type="tel" required autoComplete="tel"
            value={form.phone} onChange={update('phone')} />
        </div>
        <div className="bform__field">
          <label htmlFor="bf-travellers">Počet cestujúcich *</label>
          <select id="bf-travellers" value={form.travellers} onChange={update('travellers')}>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
          </select>
        </div>
        <div className="bform__field bform__field--full">
          <label htmlFor="bf-message">Správa</label>
          <textarea id="bf-message" rows="4" value={form.message} onChange={update('message')}
            placeholder="Kam sa chystáš? Máš otázky?" />
        </div>
      </div>

      <label className="bform__agree">
        <input type="checkbox" required checked={form.agree} onChange={update('agree')} />
        <span>
          Súhlasím s{' '}
          <a href="/obchodne-podmienky.html" target="_blank" rel="noreferrer">
            obchodnými podmienkami
          </a>{' '}
          *
        </span>
      </label>

      {status === 'error' && (
        <p className="bform__error" role="alert">
          Odoslanie sa nepodarilo. Skús to znova, alebo nám napíš priamo na
          e-mail.
        </p>
      )}

      <button
        type="submit"
        className="btn btn--primary bform__submit"
        disabled={!ready || status === 'sending'}
      >
        {status === 'sending' ? 'Odosielam…' : 'Odoslať rezervačnú požiadavku'}
      </button>
    </form>
  );
}
